import apiClient from "../../../services/apiClient";
import storageService from "../../../utils/storageService";

const root = "/emergency";

export const emergencyApi = {
    getTypes: (siteId) => apiClient.get(`${root}/types`, { params: { siteId } }),
    createType: (body) => apiClient.post(`${root}/types`, body),
    updateType: (id, body) => apiClient.put(`${root}/types/${id}`, body),
    deleteType: (id) => apiClient.delete(`${root}/types/${id}`),
    raiseAdmin: (body) => apiClient.post(`${root}/raise-admin`, body),
    getActive: (siteId, userId) => apiClient.get(`${root}/active`, { params: { siteId, userId: userId || undefined } }),
    updateStatus: (id, body) => apiClient.patch(`${root}/${encodeURIComponent(id)}/status`, body),
    history: (params) => apiClient.get(`${root}/reports/history`, { params }),
    summary: (params) => apiClient.get(`${root}/reports/summary`, { params }),
    guardPerformance: (params) => apiClient.get(`${root}/reports/guard-performance`, { params }),
};

export function readSession(user) {
    const siteId = Number(user?.siteId || user?.SiteId || storageService.getItem("siteId") || 0);
    const userId = Number(user?.userId || user?.Id || user?.id || storageService.getItem("employeeCode") || 0);
    const roleId = Number(storageService.getItem("roleId") || user?.roleId || 0);
    const personTypeId = Number(storageService.getItem("personTypeId") || user?.personTypeId || 0);
    const roleName = (user?.roleName || user?.RoleName || storageService.getItem("roleName") || "").toString().toLowerCase();
    const isVendor = roleId === 7 || personTypeId === 4;
    const isSiteAdmin = !isVendor && (roleId === 3 || roleName.includes("site admin"));
    return { siteId, userId, isSiteAdmin };
}

export function apiMessage(error, fallback) {
    return error?.response?.data?.message || error?.response?.data?.Message || fallback;
}
